import styled from "@emotion/styled";
import { Skeleton } from "@kaltura/mediaspace-shared-styled";
import { EntryListSkeleton } from "./EntryListSkeleton";

const StyledResultsNumberSkeleton = styled(Skeleton)(({ theme }) => ({
    borderRadius: theme.kaltura.shape.roundness1,
    marginBottom: theme.spacing(4),
    marginTop: theme.spacing(1),
    [theme.breakpoints.down("md")]: {
        marginBottom: theme.spacing(3),
        marginTop: theme.spacing(3),
    },
}));

/**
 * my media search results skeleton
 */
export function SearchResultsSkeleton() {
    return (
        <>
            <StyledResultsNumberSkeleton variant="rectangular" width={120} height={16} />
            <EntryListSkeleton count={4} />
        </>
    );
}
